import { capitalize } from 'vue';

import FacingDirectionEnum from '@/common/enums/FacingDirection.enum';
import i18n from '@/vueI18n';

export default class UnitFacingDirectionOptions {
  static options() {
    return Object.values(FacingDirectionEnum).map((x) => ({
      value: x,
      name: capitalize(i18n.global.t(`options.unit.facingDirection.${x}`)),
    }));
  }
}
